/* ADD CLASS TO HEADER ON SCROLL 
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 10) {
        $("header").addClass("scrolled-up");
    } else {
        $("header").removeClass("scrolled-up");
    }
});
*/


$(".js-marquee-slick").not(".slick-initialized").slick({
    speed: 4000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
    });


/* Slick needs no get Reinitialized on window Resize after it was destroyed */
$(window).on("load resize orientationchange", function () {
  $(".top-bar__info").each(function () {
    var $carousel = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 1199) {
      if ($carousel.hasClass("slick-initialized")) {
        $carousel.slick("unslick");
      }
    } else {
      if (!$carousel.hasClass("slick-initialized")) {
        $carousel.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          fade: true,
          cssEase: "linear",
          autoplay: 7000,
          dots: false,
          arrows: false,
        });
      }
    }
  });
});
var app = document.getElementById("open-text");
if (app) {
  let config = $(app).parents("[data-header_cta-animation]");

  var typewriter = new Typewriter(app, {
    loop: false,
    delay: 35,
  });

  if ($(config).data("header_cta-animation") == "sequence") {
    typewriter
      .typeString($(config).data("header_cta-body"))
      .deleteAll(10)
      .pauseFor(1000)
      .typeString($(config).data("header_cta-title"))
      .pauseFor(1000)
      .start();
  } else {
    typewriter
      .typeString(
        $(config).data("header_cta-body") +
          "<br/>" +
          $(config).data("header_cta-title")
      )
      .pauseFor(1000)
      .callFunction(function () {
        $("#open-text .Typewriter__wrapper").html(
          $(config).data("header_cta-title")
        );
      })
      .start();
  }
}

/*
const carouselText = [
  {text: "[ FREE DELIVERY OVER £30 ANYWHERE IN THE GALAXy ]"},
  {text: "[ DELIVERY OVER £30]"},
  {text: "[ FREE DELIVERY OVER £30 ANYWHERE IN THE GALAXy ]"}
]

$( document ).ready(async function() {
  let carouselText = [];
  $('#announcements span').each(function(){
    carouselText.push({text: $(this).text()})
  });
  carousel(carouselText, "#feature-text")
});
*/

/*
$( document ).ready(async function() {
  const headerText = [
    {text: $('[data-header_cta-title]').data('header_cta-title') }
  ]
  carousel(headerText, ".header-text")
});

const inputText = [
  {text: "..."}
]
$( document ).ready(async function() {
  carousel(inputText, ".input-text")
});
*/

$(window).scroll(function () {
  var scroll = $(window).scrollTop();

  if (scroll >= 1) {
    $(".go-to-page").addClass("scroll");
    $(".page-header__menu").addClass("hide");
  } else {
    $(".go-to-page").removeClass("scroll");
    $(".page-header__menu").removeClass("hide");
  }
});

async function typeSentence(sentence, eleRef, delay = 100) {
  if (sentence) {
    const letters = sentence.split("");
    let i = 0;
    while (i < letters.length) {
      await waitForMs(delay);
      $(eleRef).append(letters[i]);
      i++;
    }
    return;
  }
}

async function deleteSentence(eleRef) {
  const sentence = $(eleRef).html();
  if (sentence) {
    const letters = sentence.split("");
    let i = 0;
    while (letters.length > 0) {
      await waitForMs(100);
      letters.pop();
      $(eleRef).html(letters.join(""));
    }
  }
}

async function carousel(carouselList, eleRef) {
  var i = 0;
  if (carouselList.length > 0) {
    while (true) {
      updateFontColor(eleRef, carouselList[i].color);
      await typeSentence(carouselList[i].text, eleRef);
      await waitForMs(1500);
      await deleteSentence(eleRef);
      await waitForMs(500);
      i++;
      if (i >= carouselList.length) {
        i = 0;
      }
    }
  }
}

function updateFontColor(eleRef, color) {
  $(eleRef).css("color", color);
}

function waitForMs(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* Slick needs no get Reinitialized on window Resize after it was destroyed */
$(window).on("load resize orientationchange", function () {
  $(".product-carousel").each(function () {
    var $carousel = $(this);

    function markLastVisibleSlide() {
      $carousel.find(".slick-slide").removeClass("last-visible");
      $carousel.find(".slick-slide.slick-active").last().addClass("last-visible");
    }

    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() < 767) {
      if ($carousel.hasClass("slick-initialized")) {
        $carousel.slick("unslick");
      }
    } else {
      if (!$carousel.hasClass("slick-initialized")) {
        $carousel.slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          adaptiveHeight: true,
        });

        $carousel.on("init reInit afterChange", function () {
          markLastVisibleSlide();
        });

        $carousel.on("setPosition", function () {
          markLastVisibleSlide();
        });
      } else {
          markLastVisibleSlide();
      }
    }
  });

  $(".js-community-blocks").each(function () {
    var $community = $(this);

    if ($(window).width() < 767) {
      if ($community.hasClass("slick-initialized")) {
        $community.slick("unslick");
      }
    } else {
      if (!$community.hasClass("slick-initialized")) {
        $community.slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          adaptiveHeight: true,
        });
      }
    }
  });
});

if ($(".js-video-2").length > 0) {
  AOS.init();

  $(".aos-init").addClass("animation-done");

  $(".js-video-2").each(function () {
    this.controls = false;
  });

  $(".js-video-2").each(function () {
    if ($(this).closest(".aos-init").hasClass("animation-done")) {
      $(this).get(0).play();
      $(this).removeClass("js-video-2");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  let currentMode = null;

  initAllAnimations();

  window.addEventListener(
    "resize",
    debounce(() => {
      if (
        (window.innerWidth >= 1200 && currentMode !== "desktop") ||
        (window.innerWidth < 1200 && currentMode !== "mobile")
      ) {
        ScrollTrigger.getAll().forEach((t) => t.kill());
        resetDisplayStates();
        initAllAnimations();
      }
    }, 300)
  );

  function initAllAnimations() {
    initProductShowcaseAnimations();      
    initMoodBoostingBlendAnimations();   
    initContentStageAnimations();         
  }

  function initProductShowcaseAnimations() {
    if (window.innerWidth >= 1200) {
      currentMode = "desktop";
      if (!document.querySelector(".product-showcase")) return;

      const tab1 = document.querySelector(".animate-tab-1");
      const tab2 = document.querySelector(".animate-tab-2");
      const itemsTab1 = tab1.querySelectorAll(".animate-item");
      const itemsTab2 = tab2.querySelectorAll(".animate-item");

      const progressTl = gsap.timeline({
        scrollTrigger: {
          trigger: ".product-showcase",
          start: "top top",
          end: "25% top",
          scrub: true,
          ease: "linear",
        },
      });

      const transitionTl = gsap.timeline({
        scrollTrigger: {
          trigger: ".product-showcase",
          start: "25% top",
          toggleActions: "play pause resume reverse",
        },
        defaults: { ease: "power1.in", duration: 0.25 },
      });

      transitionTl
        .to(
          itemsTab1,
          {
            opacity: 0,
            x: "2rem",
            y: "1.5rem",
            stagger: { amount: 0.25, from: "end" },
          },
          "<"
        )
        .set(tab1, { display: "none" })
        .set(tab2, { display: "flex" }, "<")
        .from(
          itemsTab2,
          {
            opacity: 0,
            x: "2rem",
            y: "1rem",
            ease: "power1.out",
            stagger: { amount: 0.35, from: "end" },
          },
          "<"
        )
        .add(() => {
          animateNumber(".js-percentage-customers", 73, 1.5);
          animateNumber(".js-clinical-count", 35, 1.5);
        }, "<");
    } else {
      currentMode = "mobile";

      const mobileCards = document.querySelector(".js-mobile-cards");
      if (!mobileCards) return;

      ScrollTrigger.create({
        trigger: mobileCards,
        start: "top bottom",
        onEnter: () => {
          resetNumbers(
            ".js-mobile-percentage-customers",
            ".js-mobile-clinical-count"
          );
          animateNumber(".js-mobile-percentage-customers", 73, 1.5);
          animateNumber(".js-mobile-clinical-count", 35, 1.5);
        },
        onEnterBack: () => {
          resetNumbers(
            ".js-mobile-percentage-customers",
            ".js-mobile-clinical-count"
          );
          animateNumber(".js-mobile-percentage-customers", 73, 1.5);
          animateNumber(".js-mobile-clinical-count", 35, 1.5);
        },
      });
    }
  }

  function initMoodBoostingBlendAnimations() {
    const blendSection = document.querySelector(".mood-boosting-blend");
    if (!blendSection) return;

    ScrollTrigger.create({
      trigger: blendSection,
      start: "top bottom",
      onEnter: () => {
        resetNumbers(".js-percentage-customers", ".js-clinical-count");
        animateNumber(".js-percentage-customers", 73, 1.5);
        animateNumber(".js-clinical-count", 35, 1.5);
      },
      onEnterBack: () => {
        resetNumbers(".js-percentage-customers", ".js-clinical-count");
        animateNumber(".js-percentage-customers", 73, 1.5);
        animateNumber(".js-clinical-count", 35, 1.5);
      },
    });
  }

  function initContentStageAnimations() {
    if (window.innerWidth < 1200) return;

    const sections = document.querySelectorAll(".js-content-stage");
    if (!sections.length) return;

    sections.forEach((section) => {
      const image = section.querySelector(".js-content-stage-image");
      const slides = Array.prototype.slice.call(
        section.querySelectorAll(".js-content-stage-slide")
      );

      if (!image || !slides.length) return;

      const scrollDistance = 0.8; 

      gsap.to(image, {
        yPercent: -66.6667,
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top top",
          end: "+=" + scrollDistance * 100 + "%",
          scrub: true,
        },
      });

      ScrollTrigger.create({
        trigger: section,
        start: "top top",
        end: "+=" + scrollDistance * 100 + "%",
        scrub: true,
        onUpdate: function (self) {
          const steps = slides.length;
          let index = Math.floor(self.progress * steps);
          if (index >= steps) index = steps - 1;

          slides.forEach((slide, i) => {
            slide.classList.toggle("is-active", i === index);
          });
        },
      });

    const scrollLabel = section.querySelector(".js-scroll-label");

    if (scrollLabel) {
      const fullText = scrollLabel.textContent.trim(); 
      scrollLabel.textContent = "";                  

      const obj = { length: 0 };

      const typingTween = gsap.to(obj, {
        length: fullText.length,
        duration: 0.8,
        ease: "power1.inOut",
        paused: true,
         onStart() {
          scrollLabel.style.opacity = 1;
        },
        onUpdate() {
          const current = fullText.slice(0, Math.floor(obj.length));
          scrollLabel.textContent = current;
        },
      });

      typingTween.eventCallback("onReverseComplete", () => {
        scrollLabel.textContent = "";
        scrollLabel.style.opacity = 0;
      });

      ScrollTrigger.create({
        trigger: section,
        start: "top top",
        end: "+=" + scrollDistance * 100 + "%",

        onEnter: () => {
          typingTween.play(0); 
        },

        onEnterBack: () => {
          typingTween.play(0);
        },

        onLeave: () => {
          typingTween.reverse(); 
        },

        onLeaveBack: () => {
          typingTween.reverse(); 
        },
      });
    }
    });
  }

  function resetNumbers(...selectors) {
    selectors.forEach((sel) => {
      const el = document.querySelector(sel);
      if (el) el.textContent = "0";
    });
  }

  function animateNumber(selector, target, duration) {
    const el = document.querySelector(selector);
    if (!el) return;

    let obj = { value: 0 };
    gsap.to(obj, {
      value: target,
      duration: duration,
      ease: "power1.out",
      onUpdate: function () {
        el.textContent = Math.floor(obj.value);
      },
    });
  }

  function debounce(func, wait) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, arguments), wait);
    };
  }

  function resetDisplayStates() {
    const tab1 = document.querySelector(".animate-tab-1");
    const tab2 = document.querySelector(".animate-tab-2");
    if (tab1 && tab2) {
      tab1.style.display = "flex";
      tab2.style.display = "none";
    }
  }
});

$('.js-scroll-to-add-to-cart').on('click', function(e) {
  e.preventDefault();

  $('html, body').animate({
    scrollTop: 0
  }, 600);
});

// Open mobile variants
$(".js-open-mobile-variants").on("click", function (e) {
  $(this).siblings(".product-item__variants").addClass("open");
});

// Close mobile variants
$(document).on("click", function (e) {
  if (
    !$(e.target).closest(".product-item__variants").length &&
    !$(e.target).closest(".js-open-mobile-variants").length
  ) {
    $(".product-item__variants").removeClass("open");
  }
});

// Variant collection product 
$('.js-variant-collection-product').on('click', function (e) {
  const $this = $(this);
  const variantId = $this.data('variant-id'); 
  const variantPrice = $this.data('variant-price');
  const $productItem = $this.closest('.js-product-item');

  $productItem.find('.js-variant-collection-product').removeClass('active');
  $this.addClass('active');

  const $addToCartBtn = $productItem.find('.js-add-to-cart-variant-collection-product');
  $addToCartBtn.data('variant_id', variantId);

  const $priceDisplay = $productItem.find('.product-item__variant-price');
  $priceDisplay.attr('data-variant-id', variantId);
  $priceDisplay.text(variantPrice);
});

// Tooltip 

$('.js-open-tooltip').on('click', function (e) {
  e.preventDefault();
  $(this).toggleClass('active');

  const $container = $(this).closest('.tooltip-container');
  const $tooltip = $container.find('.js-custom-tooltip');

  $tooltip.toggleClass('active');
 });

$('.js-close-tooltip').on('click', function (e) {
   e.preventDefault();

   const $tooltip = $(this).siblings('.js-custom-tooltip');
   const $openTooltip = $(this).closest('.tooltip-container').find('.js-open-tooltip');
    $tooltip.removeClass('active');
    $openTooltip.removeClass('active');
});


$(".js-tab-link").on("click", function (event) {
  event.preventDefault();
  var tab_id = $(this).attr("data-tab");
  var tab = $(".js-tab-content[data-id='" + tab_id + "']");
  $(".js-tab-link").removeClass("active");
  $(".js-tab-content").removeClass("current");
  tab.addClass("current");
  $(this).addClass("active");
});

$(".dropdown-item").click(function (e) {
  $(this).toggleClass("active");
});
$(".sticky-filters .nav-link").click(function (e) {
  $(this).toggleClass("active");
});

$(".reset").click(function (e) {
  $(".dropdown-item").removeClass("active");
  $(".sticky-filters .nav-link").removeClass("active");
});

$(".open-form").click(function (e) {
  $(".addresses-form").toggleClass("hide");
});

$(".dropdown-menu label, .dropdown-menu input").click(function (e) {
  e.stopPropagation();
});

$(".progress").on("click", function () {
  var targetWidth = parseFloat($(".progress-bar").css("width"));
  var parentWidth = parseFloat($(".progress-bar").parent().css("width"));
  $(".progress-bar").css("width", (100 * targetWidth) / parentWidth + 50 + "%");
  if (targetWidth / parentWidth >= 1) {
    $(".progress").addClass("progress-bar-success");
  } else {
    $(".progress").removeClass("progress-bar-success");
  }
});

$(".js-category-title").bind("mousemove", function (e) {
  var positionLeft = $(this).offset().left,
    positionTop = $(this).offset().top,
    mousePositionLeft = e.pageX,
    mousePositionTop = e.pageY,
    top = mousePositionTop - positionTop,
    left = mousePositionLeft - positionLeft;
  $(this)
    .closest(".js-category")
    .find(".js-category-image")
    .css("top", top)
    .css("left", left);
});

//----------------------------------------------------------------------------------------------------//
function initNavButtons() {
  console.log("initNavButtons");

  // get the element that reacts to background elements
  const fabElement = document.getElementById("nav");
  // what do you want to do when it overlaps?
  function reactToOverlap(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) fabElement.classList.add("triggered");
      else fabElement.classList.remove("triggered");
    });
  }

  const observerOptions = {
    rootMargin: getDistanceToEdge(fabElement)
      .map((val) => `-${val}px`)
      .join(" "), // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#rootmargin for syntax
  };

  const observerInstance = new IntersectionObserver(
    reactToOverlap,
    observerOptions
  );

  // what elements do you want to trigger the change?
  const elementsToTriggerFab = document.querySelectorAll(".dark");
  elementsToTriggerFab.forEach((el) => observerInstance.observe(el));

  /* Represents how far the element is from the edge of the browser, in all directions. */
  function getDistanceToEdge(element) {
    const elementBounds = element.getBoundingClientRect();

    // top and left margins are identical to the pixel coordinates
    const top = elementBounds.top;
    const left = elementBounds.left;

    // bottom and right need to be subtracted from the viewport bounds
    const bottom = window.innerHeight - elementBounds.bottom;
    const right = window.innerWidth - elementBounds.right;

    return [bottom, left, top, right];
  }

  let stickyObserverElements = null;

  function updateStickyObserverElementsState() {
    // if elements are not ready yet
    if (!stickyObserverElements) {
      return;
    }

    stickyObserverElements.forEach(function (element) {
      const parentTop = element.parentElement.getBoundingClientRect().top;
      const top = Math.round(element.getBoundingClientRect().top - parentTop);

      element.style.position = "static";
      element.toggleAttribute(
        "stuck",
        top !== Math.round(element.getBoundingClientRect().top - parentTop)
      );

      element.style.position = "";
      element.dataset.prevClientTop = String(top);
    });
  }

  window.addEventListener("load", () => {
    stickyObserverElements = document.querySelectorAll(
      '[data-component~="sticky-observer"]'
    );

    updateStickyObserverElementsState();
  });

  window.addEventListener("resize", () => updateStickyObserverElementsState());

  window.addEventListener("scroll", () => {
    // if elements are not ready yet
    if (!stickyObserverElements) {
      return;
    }

    stickyObserverElements.forEach(function (element) {
      const top = Math.round(
        element.getBoundingClientRect().top -
          element.parentElement.getBoundingClientRect().top
      );

      element.toggleAttribute(
        "stuck",
        Number(element.dataset.prevClientTop) !== top
      );
      element.dataset.prevClientTop = String(top);
    });
  });
}

if (document.getElementById("nav")) {
  initNavButtons();
} else {
  $("body").on("initNavButtons", function () {
    initNavButtons();
  });
}
const scrollText = document.querySelector(".scroll-text");
const scrollTextContent = document.querySelector(".scroll-text_content");

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      scrollText.classList.add("opacity");
    } else {
      scrollText.classList.remove("opacity");
    }
  });
});

// observer.observe(scrollTextContent);

$(function () {
  $('.js-scroll-to-reviews').on('click', function (e) {
    e.preventDefault();

    var $target = $('.js-reviews-carousel').first();
    if (!$target.length) return;

    var headerOffset = 100;

    $('html, body').animate(
      { scrollTop: $target.offset().top - headerOffset },
      500
    );
  });
});